import Cut from './upload/cut.vue'
import MoreUpload from './upload/more-upload.vue'
import SkillTree from './skill-tree/skill-tree.vue'

export default {
  Cut,
  MoreUpload,
  SkillTree
}



// WEBPACK FOOTER //
// ./src/components/common.js